import { render } from "./DhButton.vue?vue&type=template&id=1b1ff27c"
import script from "./DhButton.vue?vue&type=script&lang=ts"
export * from "./DhButton.vue?vue&type=script&lang=ts"

import "./DhButton.vue?vue&type=style&index=0&id=1b1ff27c&lang=css"
script.render = render

export default script